import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import _ from 'lodash';
/**
 * Generated class for the FormatDurationPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatDuration',
})
export class FormatDurationPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(start: any, end: any, ...args) {
    if (!end) {
      let route = start,
        duration = _.sumBy(route.properties.legs, l => {
          return _.get(l, 'duration.value');
        }),
        durationStr = computeDurationStr(duration);

      return durationStr;
    } else if (end) {
      let s = moment(start),
        e = moment(end);
      let durations: any = moment.duration(s.diff(e));
      let duration = '';

      if (durations._data.days) {
        let days = Math.abs(durations._data.days);
        if (days >= 2) {
          duration = _.toString(days);
          duration += ' days ';
        } else if (days == 1) {
          duration = _.toString(days);
          duration += ' day ';
        }
      }
      if (durations._data.hours) {
        let hours = Math.abs(durations._data.hours);
        if (hours >= 2) {
          duration += _.toString(hours);
          duration += ' hours ';
        } else if (hours == 1) {
          duration += _.toString(hours);
          duration += ' hour ';
        }
      }
      if (durations._data.minutes) {
        let minutes = Math.abs(durations._data.minutes);
        if (minutes >= 2) {
          duration += _.toString(minutes);
          duration += ' minutes ';
        } else if (minutes <= 1) {
          duration = 'less than 1 minute';
        }
      }

      if (duration === '') {
        duration = 'less than 1 minute';
      }
      return duration;
    }
  }
}
function computeDurationStr(duration) {
  let hr = 0,
    min = 0;
  if (duration > 3600) {
    hr += Math.floor(duration / 3600);
    duration -= hr * 3600;
  }

  min += Math.floor(duration / 60);

  if (hr && min) {
    return `${hr} hr ${min} min`;
  } else if (hr) {
    return `${hr} hr`;
  } else {
    return `${min} min`;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-duration/format-duration.ts